export default __webpack_public_path__ + "maps-examples-user-tracking-mode-thumbnail-480-1ed83783597a223bf072e71457fd2ee3.webp";